import { z } from "zod";

export const consultantKpiObjectivesSchema = z.object({
  talentCalls: z.number(),
  temporaryWorkersOnPlanning: z.number(),
  fullTimeEquivalent: z.number(),
  occupancyPercent: z.number(),
  coefficient: z.number(),
  billedHourlyRate: z.number(),
  newCompanyMissions: z.number(),
  existingCompanyMissions: z.number(),
  newTalentPlacements: z.number(),
  existingTalentPlacements: z.number(),
  firstContractStarts: z.number(),
  recentBenchReplacements: z.number(),
  dormantBenchReactivations: z.number(),
  planningRetentionPercent: z.number(),
  netMargin: z.number(),
  netMarginRate: z.number(),
});

export type ConsultantKpiObjectives = z.infer<typeof consultantKpiObjectivesSchema>;
